import { render, staticRenderFns } from "./year_mobile_view.vue?vue&type=template&id=fcb0201a&scoped=true&"
import script from "./year_mobile_view.vue?vue&type=script&lang=js&"
export * from "./year_mobile_view.vue?vue&type=script&lang=js&"
import style0 from "./year_mobile_view.vue?vue&type=style&index=0&id=fcb0201a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb0201a",
  null
  
)

export default component.exports